export const BRANDING = {
  name: "ProposalKit",
  domain: "ProposalKit.io",
  siteUrl: "https://proposalkit.io",
  email: "hello@proposalkit.io",
  privacyEmail: "privacy@proposalkit.io",
  termsEmail: "terms@proposalkit.io",
  tagline: "Send proposals clients actually read and sign.",
  description:
    "Proposal software for agencies and service businesses, with branded client links, proposal tracking and analytics, in-page signatures, and clean PDF export.",
  logoPath: "/proposalkit_logo.png",
  ogImagePath: "/og/proposalkit-card.jpg",
  launchDate: "early 2026",

  company: {
    legalName: "Oldfire OÜ",
    address: "J. Pärna 1, Tallinn, Estonia",
    registrationNumber: "14744856",
  },

  lastUpdated: "April 29, 2026",
} as const;
